import { render, staticRenderFns } from "./Base201.vue?vue&type=template&id=8678ec3a&scoped=true&"
import script from "./Base201.vue?vue&type=script&lang=js&"
export * from "./Base201.vue?vue&type=script&lang=js&"
import style0 from "./Base201.vue?vue&type=style&index=0&id=8678ec3a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8678ec3a",
  null
  
)

export default component.exports